// services/epayco.service.ts
import { getFunctions, httpsCallable } from "firebase/functions";
import { PurchaseConcept } from "@/types/payment.types";

interface EpaycoPaymentData {
  amount: number;
  description: string;
  concepts: PurchaseConcept[];
  customerEmail: string;
  customerName: string;
  customerPhone?: string;
  customerAddress?: string;
  customerCity?: string;
  customerCC: string;
  paymentSite?: string;
}

export const epaycoService = {
  iniciarPago: async (paymentData: EpaycoPaymentData) => {
    try {

      const functions = getFunctions();
      const crearPago = httpsCallable(functions, "createPaymentEpayco");

      const { data } = await crearPago(paymentData) as any;

      const ePayco = (window as any).ePayco;

      // Verificar que el SDK de Epayco esté cargado
      if (!ePayco) {
        throw new Error("El SDK de Epayco no está cargado");
      }

      // Configurar el handler de Epayco
      const hostname = window.location.hostname;
      const isProdDomain = hostname === 'jecaro.edu.co' || hostname.endsWith('.jecaro.edu.co');
      const isProdBuild = import.meta.env.VITE_ENVIRONMENT === 'prod';
      const isTest = !isProdBuild || !isProdDomain;
      const handler = ePayco.checkout.configure({
        key: data.publicKey,
        test: isTest,
      });

      // Datos para el checkout
      const checkoutData = {
        // Identificación del comercio
        customer: data.customerId,

        // Información de la transacción
        name: data.name + " | Pago Institucional José Eusebio Caro",
        description: data.description,
        invoice: data.referenceCode,
        currency: "cop",
        amount: data.amount.toString(),
        tax_base: "0",
        tax: "0",
        country: "co",
        lang: "es",

        // Información del comprador
        external: "false",
        email_billing: data.customerEmail,
        name_billing: data.customerName,
        address_billing: paymentData.customerAddress || "default",
        type_doc_billing: "cc",
        mobilephone_billing: paymentData.customerPhone || "1234567890",
        number_doc_billing: paymentData.customerCC,

        // URLs
        response: import.meta.env.VITE_APP_URL || 'https://jecaro.edu.co/',
        confirmation:
          "https://us-central1-plataformaweb-3dc94.cloudfunctions.net/webhookEpayco",

        autoclick: "true", // Fuerza click en botón de retorno
        extra1: data.referenceCode, // Para tracking
        // Personalización
        methodsDisable: ["CASH"],
      };

      // Abrir el checkout
      handler.open(checkoutData);

    } catch (error: any) {
      console.error("Error:", error);
      alert(`Error al procesar el pago: ${error.message}`);
      throw error;
    }
  },
};